export const INDICATOR_GROUPS = {
  BASE: 'base',
  DASHBOARD: 'dashboard',
  HARVEST: 'harvest_indicators',
}

export const AGGREGATION_RESOURCES = {
  aggregate: 'aggregate',
  addGlobalConsent: 'add_global_consent',
  accounts: 'accounts',
  synchronize: 'synchronize_backend',
}

export const AGGREGATION_SUB_RESOURCES = {
  all: 'all',
  listStatus: 'list_status',
  editCredentials: 'edit_credentials',
  manageAccounts: 'manage_accounts',
}

export const OLD_AGE = 75

export const ADVISABLE_ID_KEY = 'advisable'

export const ENGINE = {
  ELIGIBLE_RISK_LEVELS: 'eligible_risk_levels',
  LOAN_CAPACITY: 'loan_capacity',
  HARVEST_INHERITANCE: 'harvest_inheritance',
  LOAN_RECOMMENDATION: 'loan_recommendation',
  MONTHLY_DEATH_BENEFIT: 'monthly_death_benefit',
  RENTAL_INVESTMENTS: 'rental_investments',
  WEALTH_RECOMMENDATION_CONTROL: 'wealth_recommendation_control',
  WEALTH_RECOMMENDATION_FEES: 'wealth_recommendation_fees',
  WEALTH_RECOMMENDATION_INHERITANCE: 'wealth_recommendation_inheritance',
  WEALTH_RECOMMENDATION_TAXATION: 'wealth_recommendation_taxation',
  WEALTH_RECOMMENDATION_PATRIMONIAL_GROWTH:
    'wealth_recommendation_patrimonial_growth',
  WEALTH_RECOMMENDATION_RISK: 'wealth_recommendation_risk',
  WEALTH_RECOMMENDATION: 'wealth_recommendation',
  WEALTH_RECOMMENDATION_SHORT_CIRCUIT: 'wealth_recommendation_fast_circuit',
  ESG_SCENARIO: 'esg_scenario',
  ESG_MESSAGE: 'esg_message',
} as const

export const ENGINES = {
  assetsHolding: 'assets_holding',
  deathBenefitRequirements: 'death_benefit_requirements',
  deathBenefits: 'death_benefits',
  debtRate: 'debt_rate',
  leverageRatio: 'leverage_ratio',
  lifeExpenses: 'life_expenses',
  lifeInsuranceImpact: 'life_assurance_impact',
  liquidity: 'liquidity',
  loanCapacity: 'loan_capacity',
  loanCapacityPrimaryResidence: 'loan_capacity_primary_residence',
  loanCapacityRentalProperty: 'loan_capacity_rental_property',
  messages: 'messages',
  none: 'none',
  precautionarySavings: 'precautionary_savings',
  retirement: 'retirement',
  riskLevel: 'risk_level',
  savingsCapacity: 'savings_capacity',
  wealthDistribution: 'wealth_distribution',
  wealthProjection: 'wealth_projection',
  wealthProjectionRecommendation: 'wealth_projection_simulation',
  wealthRecommendation: 'wealth_recommendation',
  termDateComputer: 'term_date_computer',
  retirementHypothesesProjections: 'retirement_hypotheses_projections',
  inheritance: 'inheritance',
  harvestInheritance: 'harvest_inheritance',
} as const

export type EngineType = ValueOf<typeof ENGINES>

export const PEOPLE_FILTERS = 'person_ids'
export const INDICATOR_QUERY = 'indicator'
export const STUDY_RESOURCES = {
  advisingReports: 'advising_reports',
}

export const AlgoRecommendationState = {
  NONE: '',
  ADVISABLE_WITHOUT_RECOMMENDATION: 'advisable_without_recommendation',
  ADVISABLE_WITH_RECOMMENDATION: 'advisable_with_recommendation',
  NOT_ADVISABLE: 'not_advisable',
} as const

export type AlgoRecommendationStates = ValueOf<typeof AlgoRecommendationState>
